export default __webpack_public_path__ + "static/banner_back-aa2a120f75dc813b62923ec59370f3f7.webp";